"use client";
import styles from "./Cases.module.scss";
import { useLocale } from "next-intl";

import { MagneticChipButton } from "@/components/common/Buttons/MagneticChipButton/MagneticChipButton";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import { CasesItem, ProjectItem } from "./CasesItem";

interface CasesProps {
  messages: {
    first_word: string;
    second_word: string;
    description: string;
    our_cases: string;
    projectsList: ProjectItem[];
  };
  handleHover?: () => void;
  handleLeave?: () => void;
}

export const Cases = ({ messages, handleHover, handleLeave }: CasesProps) => {
  const locale = useLocale();
  const getProjectHref = (slug: string) =>
    locale === "en" ? `/en/projects/${slug}` : `/proyectos/${slug}`;

  if (!messages.projectsList) return null;

  return (
    <section className={`${styles.sectionContainer} backgroundContainer`}>
      <div className={`${styles.casesContainer} container`}>
        <div className={styles.ourProjects}>
          <TitleAnimation
            messages={{
              first_word: messages.first_word,
              second_word: messages.second_word,
            }}
          />
          <p className={styles.description}>{messages.description}</p>
          <MagneticChipButton
            label={messages.our_cases}
            variant="outline"
            onClick={() => null}
            href={`/proyectos`}
          />
        </div>

        <div className={`${styles.cases} cases`}>
          {messages.projectsList.map((item) => (
            <CasesItem
              key={item.id}
              item={item}
              chips={item.tags}
              href={getProjectHref(item.slug)}
              handleHover={handleHover}
              handleLeave={handleLeave}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
